<div class="search-parameters">
  <div class="search-bar">
    <div class="basic-search">
      <div class="line">
        <div class="search-serial-number-label">Serial number:</div>
        <div class="search-serial-number">

          <input matInput [(ngModel)]="searchCriteria.serialNumber" [disabled]="loading"
            hideRequiredMarker class="search-input">

        </div>
        <div class="search-button">

          <button class="search-button" mat-raised-button color="primary" type="button" [disabled]="isEmptySearch()"
            (click)="search()">
            <mat-icon>search</mat-icon>
            Search
          </button>

        </div>
      </div>
      <div class="line2">
        <div class="search-advanced-link">Advanced search</div>
      </div>
    </div>

    <div class="advanced-search">
      <div class="col col1">
        <div class="label">Type designation:</div>
        <div class="label">Customer:</div>
        <div class="label">Order number:</div>
      </div>
      <div class="col col2">
        <div class="input">
          <input matInput type="text" name="typeCode" [(ngModel)]="searchCriteria.typeCode">
        </div>
        <div class="input">
          <input matInput type="text" name="customer" [(ngModel)]="searchCriteria.customer">
        </div>
        <div class="input">
          <input matInput type="text" name="orderNumber" [(ngModel)]="searchCriteria.orderNumber">
        </div>
      </div>
      <div class="col col3">
        <div class="label">Site:</div>
        <div class="label">Country:</div>
        <div class="label">City:</div>
      </div>
      <div class="col col4">
        <div class="input">
          <input matInput type="text" name="site" [(ngModel)]="searchCriteria.site">
        </div>
        <div class="input">
          <input matInput type="text" name="country" [(ngModel)]="searchCriteria.country">
        </div>
        <div class="input">
          <input matInput type="text" name="city" [(ngModel)]="searchCriteria.city">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="search-results">

  <div class="empty-resultset" *ngIf="loading">
    Loading...
  </div>

  <div class="empty-resultset" *ngIf="!loading && assets && assets.length == 0">
    No assets have been found
  </div>

  <div class="empty-resultset" *ngIf="!loading && assets==null">
    Enter search criteria
  </div>

  <ng-container *ngFor="let asset of assets">
    <asset-search-result-item [asset]="asset" />
  </ng-container>

  <div class="filler" *ngIf="assets!==undefined && assets!=null && assets.length>0"></div>

  <div #loadingTrigger class="loading-trigger">
    <p *ngIf="moreDataAvailable">Loading...</p>
  </div>

</div>